import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {IApprDocItemState, ICom0110PState} from '../../models/com/com0110p_model';
  
const initialState: ICom0110PState = {
    apprDocItem : {
        cdGrpId : '014',    // 코드그룹
        cd      : '',       // 코드
        cdNm    : '',       // 코드명
        useYn   : 'Y',      // 사용여부
        attr1   : 'N',      // 증명서여부
        rmk1    : '',       // 내용
    },   // 결재문서
}

export const com0110p_Slice = createSlice({
    name: "com0110p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setApprDocItem: (state, action:PayloadAction<IApprDocItemState>) => {
            state.apprDocItem = action.payload;
        },
    },
});

export default com0110p_Slice.reducer;
export const Com0110pAction  = com0110p_Slice.actions;
export const Com0110pReducer = com0110p_Slice.reducer;